import { Trans } from "@lingui/react/macro";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ErrorIcon } from "./icons/ErrorIcon";

export default function ErrorPage({ message }: { message: string }) {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      textAlign="center"
      height="100dvh"
      p={3}
      bgcolor="background.default"
    >
      <Stack spacing={3} alignItems="center">
        <ErrorIcon
          sx={{
            fontSize: 64,
            color: "error.main",
          }}
        />
        <Typography variant="h2">
          <Trans>Oops, something went wrong!</Trans>
        </Typography>
        <Typography>{message}</Typography>
        <Stack direction="row" spacing={2}>
          <Button variant="outlined" onClick={() => history.back()}>
            <Trans>Go back</Trans>
          </Button>
          <Button variant="contained" onClick={() => location.reload()}>
            <Trans>Refresh</Trans>
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
